/**
 * @generated SignedSource<<7380881c6006dc3560412e503f92c670>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type hierarchy_nativeIssueTable_ChildRowsPagination_query$data = {
  readonly jira: {
    readonly issueSearch: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly __typename: "JiraIssueEdge";
      } | null | undefined> | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"hierarchy_nativeIssueTable_ChildRowsPagination_queryData">;
    };
  };
  readonly " $fragmentType": "hierarchy_nativeIssueTable_ChildRowsPagination_query";
};
export type hierarchy_nativeIssueTable_ChildRowsPagination_query$key = {
  readonly " $data"?: hierarchy_nativeIssueTable_ChildRowsPagination_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"hierarchy_nativeIssueTable_ChildRowsPagination_query">;
};

import tableBody_nativeIssueTable_childIssuesPaginationQuery_graphql from './tableBody_nativeIssueTable_childIssuesPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "jira",
  "issueSearch"
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "amountOfColumns"
    },
    {
      "kind": "RootArgument",
      "name": "before"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetIds"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsContext"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "kind": "RootArgument",
      "name": "filterId"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isReparentingEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "last"
    },
    {
      "kind": "RootArgument",
      "name": "namespace"
    },
    {
      "kind": "RootArgument",
      "name": "options"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "kind": "RootArgument",
      "name": "shouldQueryFieldSetsById"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    },
    {
      "kind": "RootArgument",
      "name": "viewConfigInput"
    },
    {
      "kind": "RootArgument",
      "name": "viewId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "bidirectional",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": {
          "count": "last",
          "cursor": "before"
        },
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": tableBody_nativeIssueTable_childIssuesPaginationQuery_graphql
    }
  },
  "name": "hierarchy_nativeIssueTable_ChildRowsPagination_query",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "issueSearch",
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                },
                {
                  "kind": "Variable",
                  "name": "fieldSetsInput",
                  "variableName": "fieldSetsInput"
                },
                {
                  "kind": "Variable",
                  "name": "issueSearchInput",
                  "variableName": "issueSearchInput"
                },
                {
                  "kind": "Variable",
                  "name": "options",
                  "variableName": "options"
                },
                {
                  "kind": "Variable",
                  "name": "viewConfigInput",
                  "variableName": "viewConfigInput"
                }
              ],
              "concreteType": "JiraIssueConnection",
              "kind": "LinkedField",
              "name": "__hierarchy_nativeIssueTable__issueSearch_connection",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "cursor"
                    },
                    {
                      "concreteType": "JiraIssue",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/)
                      ]
                    }
                  ]
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "isDensityFull",
                      "variableName": "isDensityFull"
                    },
                    {
                      "kind": "Variable",
                      "name": "isInlineEditingEnabled",
                      "variableName": "isInlineEditingEnabled"
                    },
                    {
                      "kind": "Variable",
                      "name": "isReparentingEnabled",
                      "variableName": "isReparentingEnabled"
                    },
                    {
                      "kind": "Variable",
                      "name": "projectKey",
                      "variableName": "projectKey"
                    },
                    {
                      "kind": "Variable",
                      "name": "projectKeys",
                      "variableName": "projectKeys"
                    },
                    {
                      "kind": "Variable",
                      "name": "shouldQueryHasChildren",
                      "variableName": "shouldQueryHasChildren"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "hierarchy_nativeIssueTable_ChildRowsPagination_queryData"
                },
                {
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "endCursor"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "hasNextPage"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "hasPreviousPage"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "startCursor"
                    }
                  ]
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__id"
                    }
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "jira.issueSearch"
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "158b717bfb1cb64c6c0a1dd4b11a8ee5";

export default node;
